import { useAtomValue } from 'jotai';
import { isActivationCompletedAtom } from '../../atoms';

export const useIsActivationCompletedAtom = () => useAtomValue(isActivationCompletedAtom);
